export default __webpack_public_path__ + "assets/images/Payment_10.d8f2f1.avif";